document.addEventListener("DOMContentLoaded", () => {

  const uploadInput =
    document.getElementById("embroideryImageUpload");

  if (!uploadInput) return;

  uploadInput.addEventListener(
    "change",
    analyzeArtwork
  );

  function analyzeArtwork(event) {

    const file =
      event.target.files[0];

    if (!file) return;

    const img = new Image();

    img.onload = () => {

      const canvas =
        document.createElement("canvas");

      const ctx =
        canvas.getContext("2d");

      canvas.width = 150;
      canvas.height = 150;

      ctx.drawImage(
        img,
        0,
        0,
        150,
        150
      );

      const imageData =
        ctx.getImageData(
          0,
          0,
          150,
          150
        ).data;

      const colorMap = {};

      for (
        let i = 0;
        i < imageData.length;
        i += 16
      ) {

        const r =
          Math.round(imageData[i] / 64) * 64;

        const g =
          Math.round(imageData[i + 1] / 64) * 64;

        const b =
          Math.round(imageData[i + 2] / 64) * 64;

        const key =
          `${r},${g},${b}`;

        colorMap[key] =
          (colorMap[key] || 0) + 1;
      }

      const detectedColors =
Object.keys(colorMap);

const colorCount =
detectedColors.length;

const detectedColorNames =
detectedColors.map(key => {

  const rgb =
    key.split(",");

  const r =
    parseInt(rgb[0]);

  const g =
    parseInt(rgb[1]);

  const b =
    parseInt(rgb[2]);

  return {
    name: identifyColor(r,g,b),
    hex: `rgb(${r},${g},${b})`
  };

});

determineComplexity(
  colorCount,
  img,
  detectedColorNames
);

    };

    img.src =
      URL.createObjectURL(file);
  }

  function determineComplexity(
  colorCount,
  img,
  detectedColorNames
) {

    let complexity =
      "Simple";

    let digitizingFee =
      0;

    if (colorCount >= 4) {

      complexity =
        "Moderate";

      digitizingFee =
        15;
    }

    if (colorCount >= 7) {

      complexity =
        "Complex";

      digitizingFee =
        35;
    }

    if (colorCount >= 10) {

      complexity =
        "Highly Complex";

      digitizingFee =
        50;
    }
    const layer =
window.lastUploadedEmbroideryLayer;

if(layer){

layer.dataset.digitizingFee =
digitizingFee;

layer.dataset.colorCount =
colorCount;

layer.dataset.complexity =
complexity;

document.dispatchEvent(
new Event("embroideryUpdated")
);

}

    const stitchEstimate =
      estimateStitches(
        img.width,
        img.height,
        colorCount
      );

    window.detectedArtworkColors =
      colorCount;

    window.detectedArtworkComplexity =
      complexity;

    window.currentDigitizingFee =
  digitizingFee;

window.currentColorCount =
  colorCount;

window.currentComplexity =
  complexity;



    window.detectedStitchCount =
      stitchEstimate;

    updateDisplay(
  colorCount,
  complexity,
  digitizingFee,
  stitchEstimate,
  detectedColorNames
);

  }

  function estimateStitches(
    width,
    height,
    colors
  ) {

    const area =
      width * height;

    return Math.round(
      (area / 40) +
      (colors * 500)
    );

  }
  function identifyColor(r,g,b){

  if(r < 50 && g < 50 && b < 50)
    return "Black";

  if(r > 220 && g > 220 && b > 220)
    return "White";

  if(r > 180 && g > 150 && b < 80)
    return "Gold";

  if(r > 180 && g < 100 && b < 100)
    return "Red";

  if(r < 120 && g < 120 && b > 180)
    return "Blue";

  if(r < 120 && g > 150 && b < 120)
    return "Green";

  if(r > 120 && g > 120 && b > 120)
    return "Gray";

  if(r > 120 && g > 70 && b < 50)
    return "Brown";

  return "Custom Color";
}

  function updateDisplay(
  colorCount,
  complexity,
  digitizingFee,
  stitchEstimate,
  detectedColorNames
) {

    const colorList =
document.getElementById(
  "detected-thread-colors"
);

if(colorList){

  colorList.innerHTML = "";

  detectedColorNames.forEach(color => {

    const row =
      document.createElement("div");

    row.className =
      "thread-color-item";

    row.innerHTML = `
      <div
        class="thread-swatch"
        style="background:${color.hex}">
      </div>

      <span>${color.name}</span>
    `;

    colorList.appendChild(row);

  });

}
const spoolEstimate =
Math.max(
  1,
  Math.ceil(colorCount)
);
const spoolDisplay =
document.getElementById(
  "thread-spools"
);

if(spoolDisplay){
  spoolDisplay.innerText =
  spoolEstimate;
}

window.threadSpoolEstimate =
spoolEstimate;
    const colorDisplay =
      document.getElementById(
        "thread-color-count"
      );

    if (colorDisplay) {
      colorDisplay.innerText =
        colorCount;
    }

    const complexityDisplay =
      document.getElementById(
        "artwork-complexity"
      );

    if (complexityDisplay) {
      complexityDisplay.innerText =
        complexity;
    }

    const digitizingDisplay =
      document.getElementById(
        "digitizing-price"
      );

    if (digitizingDisplay) {
      digitizingDisplay.innerText =
        "$" + digitizingFee;
    }

    const stitchDisplay =
      document.getElementById(
        "stitch-count"
      );

    if (stitchDisplay) {

      stitchDisplay.innerText =
        stitchEstimate.toLocaleString();
    }

  }

});